import { Scene } from './core/Scene.js';
import { Game } from './game/Game.js';
import { gameConfig } from './config/gameConfig.js';
import VConsole from 'vconsole';

// 根据配置决定是否初始化VConsole
if (gameConfig.ui.enableDebugPanel) {
    const vConsole = new VConsole();
}

class Main {
    constructor() {
        this.scene = new Scene();
        this.scene.init();  // 确保在创建 Game 之前初始化场景
        this.game = new Game(this.scene);
        
        // 更新游戏规则中的最大步数
        const maxStepsElement = document.getElementById('maxSteps');
        if (maxStepsElement) {
            maxStepsElement.textContent = gameConfig.maxSteps;
        }
        
        this.animate();
    }

    animate() {
        requestAnimationFrame(() => this.animate());
        this.game.update();
        this.scene.renderer.render(this.scene.scene, this.scene.camera);
    }
}

// 当页面加载完成时创建应用实例
window.addEventListener('load', () => {
    new Main();
});